
export function isDateWeekend (date, setting) {
  if(date==null || setting==null) return null;
  if(setting.isSaturdayHoliday==true && date.getDay()==6) return true;
  else if(setting.isSundayHoliday==true && date.getDay()==0) return true;
  return false;    
}

export function dateDifference (d1, d2) {
  let date1 = new Date(d1);
  let date2 = new Date(d2);
  date1.setHours(0,0,0,0);
  date2.setHours(0,0,0,0);

  let time_diff = date2.getTime() - date1.getTime();
  let days_diff = time_diff / (1000 * 3600 * 24); 
  return days_diff;
}

export function formatDate (date) {
  let d = new Date(date);
  let mon = d.getMonth()+1;
  let day = d.getDate();
  let yrs = d.getFullYear();
  let response = yrs.toString() + '-' + mon.toString() + '-' + day.toString();
  return response;
}

export function formatStdDate (date) {
  if(date==null) return null;
  let d = new Date(date);
  let mon = d.getMonth()+1;
  let month = mon < 10 ? "0" + (mon).toString() : (mon).toString();
  let day = d.getDate() < 10 ? "0" + d.getDate().toString() : d.getDate().toString();
  let yrs = d.getFullYear();
  let result = yrs.toString() + '-' + month + '-' + day;
  return result;
}

export function formatDateMonthDay (date) {
  let d = new Date(date);
  
  let mon = d.getMonth();
  let day = d.getDate();
  let response = month[mon] + ' ' + day.toString();
  return response;
}

export function formatDateThisYear (date) {
  let d = new Date(date);
  let today = new Date();
  let mon = d.getMonth()+1;
  let day = d.getDate();
  let yrs = today.getFullYear();
  let response = yrs.toString() + '-' + mon.toString() + '-' + day.toString();
  return response;
}

export const DateMixin = {
    methods: {
      dateDifference,
      formatDate,
      formatDateMonthDay,
      formatDateThisYear,
      isDateWeekend,
    }
};

var month = new Array();
month[0] = "January";
month[1] = "February";
month[2] = "March";
month[3] = "April";
month[4] = "May";
month[5] = "June";
month[6] = "July";
month[7] = "August";
month[8] = "September";
month[9] = "October";
month[10] = "November";
month[11] = "December";